import '@affine/env/constant';
import '../types/types.d.ts';

import { setupGlobal } from '@affine/env/global';

setupGlobal();
